import { TranslationKeys } from '~frontend-common/i18n/english/home-structure-condition.i18n';

const keys: TranslationKeys = {
  homeStructureCondition: {
    placeholder: {
      plumbingType: 'ex. Cuivre',
      roofReplacementYear: 'ex. 2015',
      roofType: 'ex. Bardeaux d’asphalte',
      structureDamages: 'ex. Jamais',
    },
    titles: {
      plumbingType: 'Comment décririez-vous le type de plomberie?',
      roofReplacementYear: 'Quelle est la date de reconstruction ou de remplacement à 100% du toit? (Année)',
      roofType: 'Comment décririez-vous le type de toiture?',
      structureDamages:
        "Y a-t-il déjà eu des fissures/dommages dans les fondations ou une infiltration d'eau par le toit, les fondations ou les fenêtres dans les 10 dernières années?",
    },
  },
};

export default keys;
